module.exports = __webpack_public_path__ + "fonts/180ba33.woff";